import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';

import DollarTextField from '../../core/text-fields/DollarTextField';

const LeaseOverride = ({ values, defaults, onChange }) => (
  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
    <DollarTextField
      label="Monthly Payment"
      style={{ marginLeft: 10 }}
      value={values.leaseMonthlyPayment || defaults.leaseMonthlyPayment || ''}
      onChange={onChange('leaseMonthlyPayment')}
    />
    <TextField
      label="Months"
      style={{ marginLeft: 10 }}
      value={values.leaseMonths || defaults.leaseMonths}
      onChange={onChange('leaseMonths')}
    />
    <DollarTextField
      label="Down Payment"
      style={{ marginLeft: 10 }}
      value={values.leaseDownPayment || defaults.leaseDownPayment || ''}
      onChange={onChange('leaseDownPayment')}
    />
  </div>
);

const LeaseFeedPropType = PropTypes.shape({
  leaseMonthlyPayment: PropTypes.string,
  leaseMonths: PropTypes.string,
  leaseDownPayment: PropTypes.string,
});

LeaseOverride.propTypes = {
  values: LeaseFeedPropType,
  defaults: LeaseFeedPropType,
  onChange: PropTypes.func,
};

export default LeaseOverride;



// WEBPACK FOOTER //
// ./src/feed-overrides/components/LeaseOverride.jsx